var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { action } from 'mobx';
import { AbfragerQuestionAnswerPart } from '../../scenes/showQuestion/AbfragerQuestionAnswerPart';
import { Aspect_ } from '../../../../components/actor/Aspect_';
import './AbfragerThinkAndReveal.css';
let AbfragerThinkAndRevealAnswerPart = class AbfragerThinkAndRevealAnswerPart extends React.PureComponent {
    get front() {
        const { question } = this.props;
        return (React.createElement("div", { className: "front bs-callout bs-callout-info bg-info thinkandreveal_card", onClick: action(() => (question.isRevealed = true)) },
            React.createElement("table", { id: "tableVisibleSolution", style: { height: '100%', width: '100%', cursor: 'pointer' } },
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", { style: { verticalAlign: 'middle', textAlign: 'center' } },
                            React.createElement("p", { style: { fontSize: 14, color: '#666666' } }, "\u00DCberlege dir die richtige L\u00F6sung und decke dann auf."),
                            React.createElement("a", { style: { fontSize: 18, fontWeight: 'bold', textDecoration: 'none' } }, "Musterl\u00F6sung anzeigen")))))));
    }
    get back() {
        const { question } = this.props;
        return (React.createElement("div", { className: "back bs-callout bs-callout-success bg-success thinkandreveal_card" },
            React.createElement(Aspect_, { aspect: question.ownAspect.solution }),
            React.createElement("div", { id: "thinkandreveal_buttonrow", style: { paddingTop: 60, display: 'flex', justifyContent: 'space-between' } },
                React.createElement("button", { type: "button", className: "btn btn-success btn-lg", style: { marginRight: 10, cursor: 'pointer' }, onClick: action(() => {
                        question.isComplete = true;
                        question.wasKnown = true;
                    }) }, "Habe ich gewusst"),
                React.createElement("button", { type: "button", className: "btn btn-success btn-lg", style: { marginLeft: 0, cursor: 'pointer' }, title: "Die Frage wird sp\u00E4ter noch einmal wiederholt", onClick: action(() => {
                        question.isComplete = true;
                        question.wasKnown = false;
                    }) }, "Habe ich nicht gewusst"))));
    }
    render() {
        const { question } = this.props;
        return (React.createElement(React.Fragment, null,
            React.createElement(AbfragerQuestionAnswerPart, { question: question }),
            React.createElement("div", { style: { height: 400 } },
                React.createElement("div", { className: `flip-container${question.isRevealed || question.context.app.appInfo.isUserCurrentlyEditing ? ' toggle' : ''}`, style: {
                        marginTop: 5,
                        marginBottom: 5,
                        marginLeft: 'auto',
                        marginRight: 'auto'
                    } },
                    React.createElement("div", { className: "flipper" },
                        this.front,
                        this.back)))));
    }
};
AbfragerThinkAndRevealAnswerPart = __decorate([
    observer
], AbfragerThinkAndRevealAnswerPart);
export { AbfragerThinkAndRevealAnswerPart };
